module.exports = __webpack_public_path__ + "first-run.66d35195461f419f6706119a90d5c1a0.svg";